export enum DeliveryNoteListRowAction {
  CANCEL_DELIVERY_NOTE = 'cancel-delivery-note',
  PRINT_DELIVERY_NOTE = 'print-delivery-note',
}
